export var CustomWorkTimeMessageType;
(function (CustomWorkTimeMessageType) {
    CustomWorkTimeMessageType["Reseller"] = "reseller";
    CustomWorkTimeMessageType["IqosStore"] = "iqos_store";
})(CustomWorkTimeMessageType || (CustomWorkTimeMessageType = {}));
